import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Subject } from 'rxjs';
import { Observable } from 'rxjs/internal/Observable';
import { environment } from '../../../../../../../environments/environment';
@Injectable({
  providedIn: 'root'
})
export class IrsipForiegnVisitInformationService {


	ForeignVisitCountrySelectChange$ = new Subject<string>(); // or whatever type

	constructor(public http: HttpClient) { }

	triggerForeignVisitCountrySelectChange(value: string) {
		this.ForeignVisitCountrySelectChange$.next(value);
	}


	public saveForeignUniversities(payload): Observable<any> {
		return this.http.post(environment.BASE_URL_HRD_PUCA + 'irsip/saveForeignUniversities', payload)
	}

	public getForeignUniversities(id): Observable<any> {
		return this.http.get(environment.BASE_URL_HRD_PUCA + 'irsip/getForeignUniversities/'+id)
	}

	public saveProposedForeignSupervisor(payload): Observable<any> {
		return this.http.post(environment.BASE_URL_HRD_PUCA + 'irsip/saveProposedForeignSupervisor', payload)
	}

	public getProposedForeignSupervisor(id): Observable<any> {
		return this.http.get(environment.BASE_URL_HRD_PUCA + 'irsip/getProposedForeignSupervisor/'+id)
	}

	public getIrsipFormLink() : Observable<any>{
		return this.http.get(`assets/json/links.json?${Date.now()}`);
	}
}
